import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import CurrentRoleStore from './CurrentRoleStore';

class EnabledFeaturesStore extends ReduceStore {

  getInitialState() {
    return {};
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CurrentRoleStore.getDispatchToken()]);

    if (CurrentRoleStore.hasChanged()) {
      return {
        // All of this functionality has been deprecated. Eventually we should remove it, but
        // right now it's too tightly woven.
        reports: this.actionEnabled('reports'),
        importer: false, //this.actionEnabled('tools'),
        exporter: false, //this.actionEnabled('tools'),
        savedjobs: false, //this.actionEnabled('tools') && CurrentRoleStore.isAdmin(),
        crosschannel: false, //this.actionEnabled('crosschannel'),
        matching: false, //this.actionEnabled('matching'),
        syncs: false, //this.actionEnabled('syncs'),
        jobStatus: false, //this.jobsTableEnabled(),
        content: this.actionEnabled('content'),
      };
    }

    return state;
  }

  actionEnabled(action) {
    return CurrentRoleStore.getState().availableActions.indexOf(action) >= 0;
  }

  jobsTableEnabled() {
    return false;
    // return this.actionEnabled('tools')
    //   || this.actionEnabled('crosschannel')
    //   || this.actionEnabled('matching');
  }
}

const instance = new EnabledFeaturesStore(AppDispatcher);
export default instance;
